import { resolveColumns } from './columnMatching';

/**
 * Attach board settings (status colours, dropdown options) to stored template
 * columns, which keep only { id, title, type }. Matched the way apply matches
 * (lib/columnMatching); a column the board doesn't have gets no settings.
 */
export function withBoardSettings(templateColumns, boardColumns) {
  const { idMap } = resolveColumns(templateColumns, boardColumns);
  return templateColumns.map((tc) => {
    const boardCol = boardColumns.find((bc) => String(bc.id) === String(idMap[String(tc.id)]));
    return { id: tc.id, title: tc.title, type: tc.type, settings: boardCol ? boardCol.settings : undefined };
  });
}
